<section class="job-position">
  <div class="box-container">
    <div class="job-topic">
      <!-- desktop heading-->
      <div
        class="job-topic__heading job-topic__heading--desktop color-gray"
        [innerHtml]="'WORK_WITH_US.JOB_SECTION.HEADING' | translate"
      >
      </div>

      <!-- tablet heading-->
      <div
        class="job-topic__heading job-topic__heading--tablet color-gray"
        [innerHtml]="'WORK_WITH_US.JOB_SECTION.HEADING' | translate"
      >
      </div>

      <!-- mobile heading -->
      <div
        class="job-topic__heading job-topic__heading--mobile color-gray"
        [innerHtml]="'WORK_WITH_US.JOB_SECTION.HEADING' | translate"
      >
      </div>
    </div>

    <div class="box">
      <ng-container *ngFor="let item of jobPositionList">
        <div class="box__item {{ item.className }}">
          <a href="{{ item.link }}" target="_blank" rel="noopener ">
            <div class="box__image-cover">
              <div class="bg-black"></div>
              <picture>
                <source srcset="{{ item.imageWebP }}" type="image/webp" />
                <source srcset="{{ item.image }}" type="image/png" />
                <img
                  src="{{ item.image }}"
                  class="box__image"
                  alt="{{ item.imageAlt }}"
                  title="{{ item.imageAlt }}"
                  loading="lazy"
                />
              </picture>
            </div>
            <div class="box__image-text color-gray">
              {{ item.positionName }}
            </div>
            <div class="box__image-detail color-blue">
              <a
                href="{{ item.link }}"
                target="_blank"
                rel="noopener "
                class="link-app-line read-more"
                aria-label="read-more"
              >
                <span [innerHtml]="'WORK_WITH_US.JOB_SECTION.MORE_DETAIL' | translate"> </span
                ><i class="fas fa-angle-right right"></i> </a
            ></div>
          </a>
        </div>
      </ng-container>
    </div>
  </div>
</section>
